export enum ItemCategory {
  ITEM = 'Item',
  WEAPON = 'Weapon',
  ARMOR = 'Armor'
}
